import { memo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'

const SKELETON_COUNT = 4

const CardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(12)};
  padding: ${rem(16)};
`

const SkeletonCard = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: ${props => props.theme.borderRadius.M};
  border: 1px solid ${props => props.theme.palette.neutral.default.six};
  overflow: hidden;
  height: ${rem(120)};
`

const SkeletonImage = styled.div`
  width: ${rem(120)};
  min-width: ${rem(120)};
  background-color: ${props => props.theme.palette.neutral.default.six};
`

const SkeletonContent = styled.div`
  flex: 1;
  padding: ${rem(12)};
  display: flex;
  flex-direction: column;
  gap: ${rem(8)};
`

function ChatMapOffersDrawerSkeleton() {
  return (
    <CardList>
      {Array.from({ length: SKELETON_COUNT }, (_, i) => (
        <SkeletonCard key={i}>
          <SkeletonImage />
          <SkeletonContent>
            <TextLoadingBox typography="heading6" width="80%" />
            <TextLoadingBox typography="body-small" width="50%" />
            <TextLoadingBox typography="body-small" width="60%" />
          </SkeletonContent>
        </SkeletonCard>
      ))}
    </CardList>
  )
}

export default memo(ChatMapOffersDrawerSkeleton)
